import React, {useState} from 'react';
import {Link}  from 'react-router-dom';
import './resetsenha.css';

import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../Config/firebase";
import { LOGO_AUTENTICACAO, NOME_PLATAFORMA } from "../Config/branding";


function ResetSenha(){

  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [sucesso, setSucesso] = useState('');

  function recuperarSenha() {
  if (!email) {
    setSucesso("");
    setMensagem("Informe um e-mail válido");
    return;
  }

  sendPasswordResetEmail(auth, email)
    .then(() => {
      setMensagem("");
      setSucesso("E-mail de redefinição enviado com sucesso");
    })
    .catch((erro) => {
      setSucesso("");
      setMensagem("Erro ao enviar e-mail: " + erro.message);
    });
}


    return (
  <div className="login-page">
    <div className="login-card">
      <form className="form-signin">
        <img
          src={LOGO_AUTENTICACAO}
          className="login-logo"
          alt={NOME_PLATAFORMA}
        />

        <h1 className="login-title">Recuperar Senha</h1>
        <p className="login-subtitle">
          Informe seu e-mail para receber o link de redefinição
        </p>

        <input
          type="email"
          className="form-control"
          placeholder="E-mail"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        <button
          onClick={recuperarSenha}
          className="btn btn-primary btn-login"
          type="button"
        >
          Enviar
        </button>

        {mensagem && (
          <div className="alert alert-danger mt-3" role="alert">
            {mensagem}
          </div>
        )}

        {sucesso && (
          <div className="alert alert-success mt-3" role="alert">
            {sucesso}
          </div>
        )}

        <div className="login-links">
            <Link to="/app">Voltar para o login</Link>
            <span className="mx-2 text-muted">|</span>
            <Link to="/">Página principal</Link>
          </div>


        <p className="login-footer">
          © {NOME_PLATAFORMA} – Sistema de Gestão da Qualidade
        </p>
      </form>
    </div>
  </div>
);

  }

export default ResetSenha;
